import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import MenuPopupLayoutDesktop from "@baseUI/component/layout/MenuPopupLayoutDesktop";
import UIBaseView from "@baseUI/views/UIBaseView";

export default class DesktopView extends UIBaseView {

    constructor(uiModelView) {
        super(uiModelView)
    }

    setParametersSizePosition(){
        this.nameLayout = 'desktopLayout'

        this.param = {
            widthPanel: this.uiModelView.widthScreen,   //1990,  //this.uiModelView.width + 100
            panelButtonsPosition: {x: 0, y: 2200},
            spinBtn: { name: 'spin_BUTTON', position: [880, 120]},
            maxBetBtn: { name: 'bet_BUTTON', position: [730, 120]},
            autoplayBtn: { name: 'autoplay_BUTTON', position: [788, -3]},
            autoplayCounterBtnPosition: { name: 'autoplayStop_BUTTON', position: [788, -3]},
            isBottomWatch: true,
            infoBtn: {name: 'info_BUTTON'},
            menuBtn: {name: 'menu_BUTTON'},
            soundBtn: {name: 'sound_STATE'}
        }
    }

    init() {
        super.init()

        this.menuPopup = new MenuPopupLayoutDesktop()
        this.addChild(this.menuPopup)
        this.menuPopup.hide()
    }

    addSubstrateComponent(widthPanel, rectWidth){
        //         this.panelBottom.x = 2200 + this.uiModelView.shiftX
        const xStart = -widthPanel / 2 - 50
       // const xStart = - widthPanel/2 + this.uiModelView.shiftX + 210
        console.log('addSubstrateComponent : uiModelView.shiftX   :    ',this.uiModelView.shiftX)
        this.panelSubstrate.removeChildren()
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, rectWidth + 3, widthPanel + 100, 2 * rectWidth + 3, 0x323031, 0.7)
        UICreatorGraphics.addLine(this.panelSubstrate, xStart, 2 * rectWidth + 3, widthPanel/2 + 50, 2 * rectWidth + 3)
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, 2 * rectWidth + 7, widthPanel + 100, 1000, 0x323031, 0.9)
    }

    setPositionComponents(widthPanel, rectWidth){
        const yPositon = 250
        this.soundBtn.position.set(-widthPanel/2 + 250, yPositon)
        this.infoBtn.position.set(-widthPanel/2 + 150, yPositon)
        this.menuBtn.position.set(-widthPanel/2 + 60, yPositon)

        this.gameNameText.position.set(widthPanel/2 - 350, yPositon)
        this.watchText.position.set(widthPanel/2 - 100, yPositon)
        this.rtpText.position.set(0, yPositon)

        this.activeBets.position.set( -widthPanel/2, rectWidth + 5)
        this.winText.position.set(600, rectWidth + 20)
        this.winValue.position.set(this.winText.x, this.winText.y + 60)
        this.balanceText.position.set(this.soundBtn.x + 200, yPositon)
        this.balanceValue.position.set(this.balanceText.x + this.balanceText.width/2 + 20, this.balanceText.y)
    }

    update() {
    //    console.log('MobileDesktopView  update', UIFacade.menuContainer.x, UIFacade.menuContainer.y, this.x, this.y)
        // UIFacade.menuContainer.x = 1390
        // UIFacade.menuContainer.y = 2030 + window.app.stage.y / UIFacade.model.resizeData.scale
        this.x = 1390
        this.y = 0//400 + window.app.stage.y / this.uiModelView.scale
        this.addSubstrateComponent( this.uiModelView.widthScreen, 110)
        this.setPositionComponents( this.uiModelView.widthScreen, 110)
        this.panelBottom.y = 1800//2300 + this.uiModelView.shiftY
        this.panelButtons.y = 1770//2200 + this.uiModelView.shiftY
        // this.menuPopup.y = 300 + this.uiModelView.shiftY/3

        this.menuPopup.updateSize(this.uiModelView)
    }

}
